<template>
<div class="prebuild-model--card">
    <div class="prebuild-model--card--wrapper">
        <h6 class="card-header">
            {{prebuiltModel.name}}
        </h6>
        <div class="card-body">
            <div class="card-description">
                {{prebuiltModel.description}}
            </div>
        </div>
    </div>
    <or-button
        class="manage-btn"
        size="normal"
        type="secondary"
        color="primary"
        :class="{ borderless: isAdded}"
        @click.prevent="openManageModal"
    >
        {{ $t(`generic.${isAdded ? 'manage' : 'import'}`) }}
    </or-button>
    <ImportModal
      ref="importPrebuiltModel"
      :importModelTitle="importModelTitle"
      :prebuiltModel="prebuiltModel"
      :contexts="contexts"
      :isLoading="isRemoving"
      :isAdded="isAdded"
      @prebuilt-model::remove="openRemoveModal"
    />
    <RemovePrebuiltModal
      ref="removePrebuiltModel"
      :removeModelTitle="removeModelTitle"
      :isRemoving="isRemoving"
      @prebuilt-model::remove="removePrebuiltModel"
    />
</div>
</template>

<script>
import { mapActions } from 'vuex'
import RemovePrebuiltModal from './modals/remove-prebuilt-modal'
import ImportModal from './modals/import-modal'

export default {
  name: 'prebuilt-model-card',

  components: {
    RemovePrebuiltModal,
    ImportModal
  },

  props: {
    prebuiltModel: Object,
    isAdded: Boolean,
    contexts: Array
  },

  data () {
    return {
      isRemoving: false
    }
  },

  computed: {
    importModelTitle () {
      if (this.$props.prebuiltModel) {
        return this.$t(
          'model.nlu-model.prebuilt-models.prebuilt-model-card.importDomain.titleWithName',
          {
            action: this.$t(`generic.${this.isAdded ? 'manage' : 'import'}`),
            name: this.$props.prebuiltModel.name
          }
        )
      }
      return this.$t('model.nlu-model.prebuilt-models.prebuilt-model-card.importDomain.title')
    },

    removeModelTitle () {
      if (this.$props.prebuiltModel) {
        return this.$t(
          'model.nlu-model.prebuilt-models.prebuilt-model-card.removeDomain.titleWithName',
          { name: this.$props.prebuiltModel.name }
        )
      }
      return this.$t('model.nlu-model.prebuilt-models.prebuilt-model-card.removeDomain.title')
    }
  },

  methods: {
    ...mapActions('knowledgebase/prebuiltModels', ['removePrebuiltModeFromKM']),

    openManageModal () {
      this.$refs.importPrebuiltModel.$refs.modal.open()
    },

    openRemoveModal () {
      this.$refs.removePrebuiltModel.$refs.modal.open()
    },

    async removePrebuiltModel () {
      this.isRemoving = true
      try {
        await this.removePrebuiltModeFromKM({
          prebuiltModelId: this.$props.prebuiltModel.id
        })
        this.$refs.removePrebuiltModel.$refs.modal.close()
        this.$refs.importPrebuiltModel.$refs.modal.close()
      } catch (error) {
        console.error(error)
      }
      this.isRemoving = false
    }
  }
}
</script>

<style lang="scss" scoped>
.prebuild-model--card {
    max-width: 240px;
    min-height: 192px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: white;
    border-radius: $sp-1;
    border: 1px solid rgb(223, 223, 223);
    padding: $sp-3;
    .prebuild-model--card--wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        .card-body {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
    .text {
        font-size: 14px;
        line-height: 21px;
    }
    .card-header {
        margin: 0;
        margin-bottom: $sp-2;
        padding: $sp-2 0;
        color: rgb(30, 35, 43);
        font-size: 14px;
        font-weight: bold;
        text-align: center;
    }
    .card-description {
        color: rgb(30, 35, 43);
        font-size: 14px;
        font-weight: normal;
        margin-bottom: $sp-2;
    }
    .manage-btn {
        width: 100%;

        &.borderless {
          border: none;
        }
    }
}
</style>
